export default [
  {
    icon: 'blanche',
    title: '8 Técnicas',
    afterTitle: 'do <i>chef</i><br /> Onildo Rocha',
    action: {
      to: '#conheca',
      label: 'Saiba mais',
      color: 'primary',
    },
  },
  {
    icon: 'notebook',
    title: 'Acesso ilimitado',
    afterTitle: 'para ver e rever<br /> onde quiser',
    action: {
      to: '#conheca',
      label: 'Saiba mais',
      color: 'primary',
    },
  },
  {
    icon: 'dish',
    title: '6 pratos',
    afterTitle: 'autorais para você reproduzir',
    action: {
      to: '#conheca',
      label: 'Saiba mais',
      color: 'primary',
    },
  },
]
